import { render } from "./FormInvalidFeedback.vue?vue&type=template&id=4c645282"
import script from "./FormInvalidFeedback.vue?vue&type=script&lang=js"
export * from "./FormInvalidFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__